import { KeyStagesSlug } from "@twinkltech/curriculum-architect-domain-hooks";

import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const getKeyStageDisplayLabel = (
  keyStage: KeyStagesSlug | string
): string => {
  switch (keyStage) {
    case "eyfs":
      return i18n.t("key-stages.eyfs", { ns: COMMON_NS });
    case "en-gb-key-stage-1":
      return i18n.t("key-stages.en-gb-key-stage-1", { ns: COMMON_NS });
    case "en-gb-key-stage-2":
      return i18n.t("key-stages.en-gb-key-stage-2", { ns: COMMON_NS });
    case "en-gb-key-stage-1-and-2":
      return i18n.t("key-stages.en-gb-key-stage-1-and-2", { ns: COMMON_NS });
    case "en-gb-key-stage-lower-2":
      return i18n.t("key-stages.en-gb-key-stage-lower-2", { ns: COMMON_NS });
    case "en-gb-key-stage-upper-2":
      return i18n.t("key-stages.en-gb-key-stage-upper-2", { ns: COMMON_NS });
    case "nursery":
      return i18n.t("key-stages.nursery", { ns: COMMON_NS });
    case "reception":
      return i18n.t("key-stages.reception", { ns: COMMON_NS });
    case "year-1":
      return i18n.t("key-stages.year-1", { ns: COMMON_NS });
    case "year-2":
      return i18n.t("key-stages.year-2", { ns: COMMON_NS });
    case "year-3":
      return i18n.t("key-stages.year-3", { ns: COMMON_NS });
    case "year-4":
      return i18n.t("key-stages.year-4", { ns: COMMON_NS });
    case "year-5":
      return i18n.t("key-stages.year-5", { ns: COMMON_NS });
    case "year-6":
      return i18n.t("key-stages.year-6", { ns: COMMON_NS });
    default:
      return i18n.t("key-stages.unknown", { ns: COMMON_NS, keyStage });
  }
};
